import { Injectable } from '@angular/core';
import { DataService } from 'app/shared/services/data.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { Observable } from 'rxjs';
import { IResult } from 'app/shared/models/result.model';
import { map } from 'rxjs/operators';
import { IDtoRiskPremium } from 'app/shared/models/organization/dto-risk-premium.model';
import { IDtoCompany } from 'app/shared/models/organization/dto-company.model';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { ISelect } from 'app/shared/models/select.model';
import { IDtoEmployerRegister } from 'app/shared/models/organization/dto-employer-register.model';
import { IDtoEmployerRegisterOffice } from 'app/shared/models/organization/dto-employer-register-office.model';

@Injectable()
export class OrganizationService {
    private quoteUrl = '';
    private recruitmentUrl = '';
    constructor(private service: DataService, private configurationService: ConfigurationService) {
        if (this.configurationService.isReady) {
            this.quoteUrl = this.configurationService.serverSettings.quoteUrl;
            this.recruitmentUrl = this.configurationService.serverSettings.recruitmentUrl;
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.quoteUrl = this.configurationService.serverSettings.quoteUrl;
                this.recruitmentUrl = this.configurationService.serverSettings.recruitmentUrl;
            });
        }
    }
    public getCompanies(): Observable<IResult> {
        const url = `${this.quoteUrl}api/Companies/getCompanies`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogCompanies(): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/Companies/getCatalogCompanies`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogCustomerTypes(): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/CustomerTypes/getCatalogCustomerTypes`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogPaymentTerms(): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/PaymentTerms/getCatalogPaymentTerms`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public updateRiskPremium(dto: IDtoRiskPremium): Observable<IResult> {
        const url = `${this.quoteUrl}api/RiskPremiums/updateRiskPremium`;
        return this.service.putWithId(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public addRiskPremium(dto: IDtoRiskPremium): Observable<IResult> {
        const url =`${this.quoteUrl}api/RiskPremiums/addRiskPremium`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getRiskPremiumByCompanyId(companyId: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/RiskPremiums/getRiskPremiumByCompanyId?companyId=${companyId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public updateCompany(dto: IDtoCompany): Observable<IResult> {
        const url = `${this.quoteUrl}api/Companies/updateCompany`;
        return this.service.putWithId(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public addCompany(dto: IDtoCompany): Observable<IResult> {
        const url =`${this.quoteUrl}api/Companies/addCompany`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getCompanyById(id: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/Companies/getCompanyById?id=${id}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogZones(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/zones/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getEmployerRegistersByCustomerId(customerId: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/EmployerRegisters/getEmployerRegistersByCustomerId?customerId=${customerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public updateEmployerRegister(dto: IDtoEmployerRegister): Observable<IResult> {
        const url = `${this.quoteUrl}api/EmployerRegisters/updateEmployerRegister`;
        return this.service.putWithId(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public addEmployerRegister(dto: IDtoEmployerRegister): Observable<IResult> {
        const url =`${this.quoteUrl}api/EmployerRegisters/addEmployerRegister`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getCatalogEmployerRegistersByCustomerId(customerId: number): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/EmployerRegisters/getCatalogEmployerRegistersByCustomerId?customerId=${customerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getEmployerRegisterOfficesByProjectCustomerId(projectCustomerId: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/EmployerRegisterOffices/getEmployerRegisterOfficesByProjectCustomerId?projectCustomerId=${projectCustomerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public updateEmployerRegisterOffice(dto: IDtoEmployerRegisterOffice): Observable<IResult> {
        const url = `${this.quoteUrl}api/EmployerRegisterOffices/updateEmployerRegisterOffice`;
        return this.service.putWithId(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public addEmployerRegisterOffice(dto: IDtoEmployerRegisterOffice): Observable<IResult> {
        const url =`${this.quoteUrl}api/EmployerRegisterOffices/addEmployerRegisterOffice`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getCatalogEmployerRegisterOfficesByProjectCustomerId(projectCustomerId: number): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/EmployerRegisterOffices/getCatalogEmployerRegisterOfficesByProjectCustomerId?projectCustomerId=${projectCustomerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
}